import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';
import { timeConvert } from 'projects/selflearnv2-ui/src/app/helpers/functions';
import { toNumber } from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';
import { QuitPracticeDialogComponent } from '../quit-practice-dialog/quit-practice-dialog.component';
import { UserFeedbackPopupComponent } from '../../shared/components/user-feedback-popup/user-feedback-popup.component';

@Component({
  selector: 'app-exercise-questions',
  templateUrl: './exercise-questions.component.html',
  styleUrls: ['./exercise-questions.component.css']
})
export class ExerciseQuestionsComponent implements OnInit {
  exerciseData:any;
  userInfo:any;
  userId:any;
  questionsData:any;
  currentQuestionData:any;
  currentQuestionNumber:any = 0;
  defaultQuestion: number = 0;
  disablePrev: boolean = true;
  disableNext: boolean = false;
  public flagData: any = {
    showCorrectChoice: false,
    isSolution: false,
    showSolutionBtn: false,
    isDisabled: false,
    isSelected: false,
    enableNextBtn: false,
    isPractice: true,
    isFeedback: false,
    isQuestionSubmit: false,
    isQuit: true,
    isQuestionSkipped: false,
    enableSkipBtn: false,
    localBookmarkFlag: false

  }
  public selectedData: any = {
    index: null,
    selectedQuestionData: null,
    selectedQuestionChoiceData: null,
    selectedOption: null,
    selectedOptionNumber: 0,
    reportErrorArray: []
  }
  public deviceWidth:any;
  public type: 'practice' | 'feedback' = 'practice';
  public topicAndSubTopic: any = null;
  public revCardNo: any = 0;
  public revCardData: any = {};
  public progresses: any = [];
  progIndex: number = -1;
  questionSubmitMessage: any;
  timeConvert = timeConvert
  // start of  Different question types
  matrixColumns: any = [
    ['P', 'Q', 'R', 'S'],
    ['A', 'B', 'C', 'D', 'E']
  ]
  matrixReponses: any = {};
  selectedAnswerr: any = [];
  numPadDigits1To9: any = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];
  selectedNPadBtnText = '';
  selectedMultiAnswer: any = {};
  // end of Different question types
  public initialLoading = true;
  attemptedQuestion:boolean = false;
  @ViewChild("questioncontainer") questioncontainer: ElementRef;
  currentTime: number = new Date().getTime();
  questionList:any = []
  timeSpent: number=0;
  interval:any;
  showGifIcon:any = true;
  isCurrentQuestionSubmitted:boolean = false;
  exerciseQuestionsData:any;
  scheduleid:any;
  ruleId:any;
  answeresQuestionData:any;
  userLikeStatus: boolean = false;
  userDislikeStatus: boolean = false;
  constructor(public router: Router, public selfLearnService: SelfLearnService, public dialog: MatDialog,public spinner:NgxSpinnerService) { }

  ngOnInit(): void {
    this.startTimer();
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.userId = this.userInfo.userDto.userId;
    this.exerciseData = JSON.parse(localStorage.getItem('exerciseData'));
    this.exerciseQuestionsData = JSON.parse(localStorage.getItem('exerciseQuestionsData'));
    if( this.exerciseQuestionsData){
      this.questionsData = this.exerciseQuestionsData.questions.subjects[0].questions;
      this.scheduleid = this.exerciseQuestionsData.questions.examschedule_id;
      
      this.setDefaultInfoForQuestions();
      }else{
        this.getPracticeQuestions();
      }

   
  }
  startTimer() {
    this.interval = setInterval(() => {
      if(!this.questionsData[this.currentQuestionNumber].questionInfo.isSubmitted)
           this.timeSpent++;
    },1000)
  }

  setDefaultInfoForQuestions(){
    this.getExcerciseExamResponses();
  }
  getPracticeQuestions(){
    this.scheduleid = this.exerciseData.sheduleid;
    this.ruleId = this.exerciseData.ruleid;
    let payload:any = {
        "clearcache":true,      
        "attempt":this.exerciseData.attemptnumber.toString(),     
        "ruleid":this.exerciseData.ruleid,        
        "scheduleid":this.exerciseData.sheduleid,       
        "studentid":this.userId.toString()      
    }
this.selfLearnService.getPracticeQuestions(payload).subscribe((res:any) =>{
      console.log(res);
      this.questionsData = res.questions.subjects[0].questions;
      this.setDefaultInfoForQuestions();
     
})
  }


  quitPractice() {
    const config: MatDialogConfig = {
      // width: '620px',
      panelClass: ['qiut-practice-modal', 'mweb-stiky-bottom'],
      data: {
        topicName: this.selfLearnService.getTopicName(),
        type: "Quit Exercise",
      }
    };
    this.dialog.open(QuitPracticeDialogComponent, config);

  }
  radioChange(answer: any, selectedIndex:any) {
    this.currentQuestionData.questionInfo.questionResponse =  answer.choiceid.toString();
    this.questionsData[this.currentQuestionNumber].questionInfo.questionResponse = answer.choiceid.toString();
    this.selectedData.selectedOption = answer;
    this.selectedData.selectedOptionNumber = selectedIndex
    this.flagData.isSelected = true;
    this.saveIndex(selectedIndex-1);
    // this.flagData.isDisabled = true;
  }
  // selectedAnswer(selectedQuestionData:any, selectedQuestionChoiceData:any) {
  //   this.flagData.isQuestionSubmit = true
  //   this.selectedData.selectedQuestionData = selectedQuestionData
  //   this.selectedData.selectedQuestionChoiceData = selectedQuestionChoiceData
  // }
  isIncorrect(qc:any, option: number): boolean {
    if(this.questionsData[this.currentQuestionNumber].questionInfo.questionResponse == option){
      return option !== toNumber(this.currentQuestionData.questionanswer[0]);
    }else{
      return false;
    }
    
  }
  // padBtnClick(e: any, btnVal: any) {
  //   e.preventDefault();
  //   e.stopPropagation();
  //   let newAns: any;
  //  //const  currentAns = this.selectedAnswer[0] || "";
  //   let  currentAns:any = this.selectedAnswer || "";
  //   if (btnVal == "clear") {
  //     if (currentAns.length > 1) {
  //       newAns = [currentAns.substring(0, currentAns.length - 1)];
  //     } else {
  //       newAns = [];
  //     }
  //     this.selectedNPadBtnText = "";
  //   } else {
  //     if (this.revCardData.questiontype == 'Integer') {
  //       if (/^[0-9]$/.test(btnVal)) {
  //         this.selectedNPadBtnText = btnVal;
  //         newAns = [btnVal];
  //       } else {
  //         this.selectedNPadBtnText = "";
  //         newAns = [];
  //       }
  //     }
  //     else if (btnVal == "-") {
  //       if (currentAns[0] != "-") {
  //         if (currentAns.length >= 20) {
  //           alert("Answer should have less than 20 characters");
  //         } else {
  //           this.selectedNPadBtnText = "-";
  //           if (currentAns[0] == ".") {
  //             newAns = [("-0" + currentAns)];
  //           } else {
  //             newAns = [("-" + currentAns)];
  //           }
  //         }
  //       } else {
  //         newAns = [(currentAns.substring(1))];
  //       }
  //     } else if (btnVal == ".") {
  //       if (currentAns.indexOf(".") < 0) {
  //         if (currentAns.length >= 20) {
  //           alert("Answer should be less than 20 characters");
  //         } else {
  //           this.selectedNPadBtnText = ".";
  //           if (currentAns == "-") {
  //             newAns = [("-0.")];
  //           } else {
  //             newAns = [(currentAns + ".")];
  //           }
  //         }
  //       }
  //     } else if (currentAns.length >= 20) {
  //       alert("Answer should be less than 20 characters");
  //     }
  //     else {
  //       let decPointPos = currentAns.indexOf("."), canAppend = true;
  //       if (decPointPos >= 0) {
  //         if (currentAns.length >= decPointPos + 5) {
  //           canAppend = false;
  //           alert("only 4 decimal places are allowed");
  //         }
  //       }
  //       if (canAppend) {
  //         this.selectedNPadBtnText = btnVal;
  //         newAns = [(currentAns + btnVal)];
  //       }
  //     }
  //   }
  //   this.selectedAnswer = newAns || this.selectedAnswer;
  // }
  saveIndex(i: any) {
    this.selectedData.index = i;
  }

  isCorrect(qc:any, option: number): boolean {
    return option === toNumber(this.questionsData[this.currentQuestionNumber].questionanswer[0]);
  }
  showSolution(): any {
    this.flagData.isSolution = true;
    this.getVideoSolution();
  }

  showSolutionMobile(): any {
    this.flagData.isSolution = !this.flagData.isSolution
  }
  nextQuestion(){
    // this.flagData.isDisabled = false
    // this.flagData.showCorrectChoice = false
    // this.flagData.enableNextBtn = false;
    // this.flagData.enableSkipBtn  = false
    //this.selectedData.index = null
    if(this.currentQuestionNumber >= this.questionsData?.length-1){
      this.calculateTotalScore();
    
    }else{
      this.flagData.isSolution = false;
      this.currentQuestionData = this.questionsData[++this.currentQuestionNumber];
      console.log(toNumber(this.questionsData[this.currentQuestionNumber].questionanswer[0]))   
      this.updateCurrentQuestionTimer();
    }

    
  }
  submitSelectedQuestion(){
    this.questionsData[this.currentQuestionNumber].questionInfo.isSubmitted = true;
    this.questionsData[this.currentQuestionNumber].questionInfo.questionStatus = "answered"
    this.questionsData[this.currentQuestionNumber].questionInfo.timeSpentOnQuestion = this.timeSpent;
    this.questionsData[this.currentQuestionNumber].questionInfo.isCorrect = this.isCorrect(12, Number(this.questionsData[this.currentQuestionNumber].questionInfo.questionResponse))
    this.questionsData[this.currentQuestionNumber].questionInfo.marks = this.isCorrect(12, Number(this.questionsData[this.currentQuestionNumber].questionInfo.questionResponse)) ? 1 : 0
    this.questionsData[this.currentQuestionNumber].questionInfo.questionResponseTimeStamp = moment().unix().toString();
    this.saveQuestionResponse(this.questionsData[this.currentQuestionNumber].questionInfo);

  }
  skipQuestion(){
    if(this.currentQuestionNumber >= this.questionsData?.length-1){
      this.calculateTotalScore();
    }else{
      this.flagData.isSolution = false;
      this.questionsData[this.currentQuestionNumber].questionInfo.timeSpentOnQuestion = this.timeSpent;
      this.currentQuestionData = this.questionsData[++this.currentQuestionNumber];
      this.updateCurrentQuestionTimer();
    }
  }
  previousQuestion(){
    this.flagData.isSolution = false;
    this.questionsData[this.currentQuestionNumber].questionInfo.timeSpentOnQuestion = this.timeSpent;
    this.currentQuestionData = this.questionsData[--this.currentQuestionNumber]; 
    this.updateCurrentQuestionTimer();
  }
  isDoneBtnDisabled(){
    return false;
  }
  saveQuestionResponse(payLoad:any){

    this.selfLearnService.saveQuestionResponse(payLoad).subscribe((res:any) => {

    })
  }
  getExcerciseExamResponses(){
   let payLoad = {
      "scheduleid": this.scheduleid,
      "ruleid": this.ruleId,
      "studentid": this.userId,
      "attempt": this.exerciseData.attemptnumber.toString(),
    }
    this.selfLearnService.getExcerciseExamResponses(payLoad).subscribe((res:any) => {
      this.answeresQuestionData = res;
      this.questionsData.map((question:any,index:any) =>{
        let tempQueData:any;
        if( this.answeresQuestionData.length >0){
           tempQueData = this.answeresQuestionData.find((item:any) => item.questionid == question.questionid)
        }
        if(tempQueData &&  this.answeresQuestionData.length >0  ){
          question.questionInfo = tempQueData;
        }else{
          question.questionInfo = {
            "tenantId": this.userInfo.userDto.tenantId.toString(),
            "studentid": this.userId.toString() ,
            "phone": this.userInfo.phoneNumber,
            "admissionNumber": this.userInfo.userDto.admissionNumber,
            "scheduleid": this.scheduleid, 
            "ruleid": this.ruleId,
            "questionid": question.questionid,
            "marks": 0,
            "questionResponse": "null",
            "questionStatus": "notAnswered",
            "questionIndex": index.toString(),
            "questionSubject": question.subjectname,
            "questionResponseTimeStamp":"",
            "startExamTimeStamp": moment().unix().toString(),
            "timeSpentOnQuestion": 0,
            "attempt": this.exerciseData.attemptnumber.toString(),
            "isVisited":false,
            "isSubmitted":false,
    
        }
        }

      })
      if(this.answeresQuestionData.length > 0){
        if( localStorage.getItem('exerciseCurrentQuestion')){
          this.currentQuestionNumber = Number(localStorage.getItem('exerciseCurrentQuestion'));
          this.showSolution();
          localStorage.removeItem('exerciseCurrentQuestion')
        }else{
          this.currentQuestionNumber = this.answeresQuestionData.length-1; 
        }

      }else{
        this.currentQuestionNumber =0;
      }
     
      this.currentQuestionData = this.questionsData[this.currentQuestionNumber];
      this.updateCurrentQuestionTimer()
    })
  }
  updateCurrentQuestionTimer(){
  let tempQuestionData:any =  this.questionsData[this.currentQuestionNumber];
  clearInterval(this.interval)
  this.timeSpent = tempQuestionData.questionInfo.timeSpentOnQuestion? tempQuestionData.questionInfo.timeSpentOnQuestion : 0;
  this.isCurrentQuestionSubmitted = tempQuestionData.questionResponse  == "null" ? 0 : tempQuestionData.questionResponse;
  this.startTimer();
  }
  fmtMSS(s:any){   
  return(s-(s%= 60))/60 +(9 < s ? ':':':0') + s ;      
  }

  calculateTotalScore(){
    let correctAnswersCount = 0;
    let submitResponses:any =[]
    this.questionsData.map((question:any,index:any) =>{
     let tempObj =     {
      "chapter":question.chapter,
      "questionid": question.questionid,
      "answer_given": question.questionInfo.isSubmitted,
      "iscorrectanswer": question.questionInfo.isCorrect ? "Y" : "N",
      "ismarkedforreview": false,
      "isvisited":  question.questionInfo.isVisited,
      "selectedanswer": question.questionInfo.questionResponse == "null" ?[] :[question.questionInfo.questionResponse],
      "visitedtime":question.questionInfo.questionResponseTimeStamp,
      "marks": question.questionInfo.marks
    }
    submitResponses.push(tempObj)
      if(question.questionInfo.isCorrect){
        correctAnswersCount++
      }
    });
    this.constructSubmitPayload(submitResponses,correctAnswersCount);
    console.log(correctAnswersCount);
  }

  constructSubmitPayload(submitQuestionResponses:any,score:any){
   

    let payLoad:any = {
      "scheduleid": this.scheduleid.toString(),
      "studentid": this.userId.toString(),
      "attempt": this.exerciseData.attemptnumber.toString(),
      "phone":  this.userInfo.userDto.phone.toString(),
      "admissionNumber": this.userInfo?.userDto?.admissionNumber?.toString(),
      "ruleid": this.ruleId,
      "questionanswer": [
        {
          "subjectname":this.selfLearnService.getSubjectName(),
          "subjectid": this.selfLearnService.getSubjectId(),
          "responses": submitQuestionResponses

        }
      ],
      "examsubmittedon": moment().unix(),
      "studentClass":this.selfLearnService.getCmsGradeName(),  
    }
    localStorage.removeItem('examresultData');
    this.selfLearnService.submitExerciseExam(payLoad).subscribe((res:any) => {
      let result:any = res;
      let accuracy:any = (result.subject_scores[0].total_correct_answers/( result.subject_scores[0].total_questions - result.subject_scores[0].totalunattemptedquestions))*100;
      result.accuracy = accuracy;
      if(res.percentage >=80){

        let payloadExerciseSubmit:any = {
          "ruleId": this.ruleId,
          "scheduleId": this.scheduleid,
          "examId": Number(this.selfLearnService.getCmsExamID()),
          "gradeId": Number(this.selfLearnService.getGradeId()),
          "subjectId": Number(this.selfLearnService.getSubjectId()),
          "chapterId": Number(this.selfLearnService.getChapterId()),
          "topicId": Number(this.selfLearnService.getTopicId()),
          "topicName": this.selfLearnService.getTopicName(),
          "chapterName": this.selfLearnService.getChapterName(),
          "isCompleted": true
        }
        this.selfLearnService.updateExerciseProgress(payloadExerciseSubmit).subscribe((res:any) => {

        })
      }
      localStorage.setItem('examresultData',JSON.stringify(result));
      let viweSolutionPayload:any = {
        "clearcache":true,          
        "ruleid":this.ruleId,        
        "scheduleid":this.scheduleid,       
        "studentid":this.userId.toString()      
    
    }
    localStorage.setItem('viweSolutionPayload',JSON.stringify(viweSolutionPayload));
    this.router.navigate([`selfLearn-V2/exercise-completion`]);
    })
  }
  redirectToVideoPage(){
    localStorage.removeItem("selfLearnSelectedPlayList");
    localStorage.removeItem("selfLearnPreviousPage", );
    localStorage.removeItem('selfLearnSelectedVideoId')
    localStorage.setItem('selectedTopicName',this.selfLearnService.getTopicName())
    localStorage.setItem("selfLearnPreviousPage", 'selfLearn-V2/exercise-questions');
    localStorage.setItem('exerciseCurrentQuestion',this.currentQuestionNumber);
    localStorage.setItem('selfLearnSelectedVideoId', this.questionsData[this.currentQuestionNumber]?.Video_SolutionID)
    this.router.navigateByUrl('selfLearn-V2/videoplayback');
  }
  getVideoSolution() {

    if (this.questionsData[this.currentQuestionNumber].Video_SolutionID!='' &&!this.questionsData[this.currentQuestionNumber].video_solution_data) {
 
      this.selfLearnService.getVideoCms(Number(this.questionsData[this.currentQuestionNumber].Video_SolutionID)).subscribe((resp: any) => {
        if(resp?.video){
          resp.video.videoUrl =  resp.video.videoURL;
          resp.video.videoName = resp?.video?.title
        }
        console.log(  this.questionsData[this.currentQuestionNumber].question)
        this.questionsData[this.currentQuestionNumber].video_solution_data = { ...resp?.video }
        console.log(  this.questionsData[this.currentQuestionNumber].question)
        this.questionsData[this.currentQuestionNumber].duration = this.timeConvert(resp?.video?.duration||0) 
       
      })
    }
  }

  userLike(){
    this.userLikeStatus = !this.userLikeStatus;
  }

  userDislike(){
    this.userDislikeStatus = !this.userDislikeStatus;
    const dialogRef = this.dialog.open(UserFeedbackPopupComponent, {
      data: {assetType:"questionFeedback",
      assetId:this.questionsData[this.currentQuestionNumber].questionid}
    });
    
    dialogRef.afterClosed().subscribe(() => {
    });
  }
  openUserFeedbackDialog() {
    const dialogRef = this.dialog.open(UserFeedbackPopupComponent, {

      data: {assetType:"questionReport",
      assetId:  this.questionsData[this.currentQuestionNumber].questionid}
    });

    dialogRef.afterClosed().subscribe(() => {
    });
  }
}
